// extracted by mini-css-extract-plugin
export default {"login":"Login_login__yplOB","login__form":"Login_login__form__6mIQB"};